var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20C19.7273 20.2033 19.4293 20.379 19.106 20.527C18.066 21 16.692 21 13.943 21H8.057C5.308 21 3.934 21 2.894 20.527C2.57783 20.3842 2.27808 20.2075 2 20M17.5 9H17.491M4.5 9H4.491M1 9C1 5.463 1 3.694 2.053 2.513C2.22167 2.32367 2.40633 2.14967 2.607 1.991C3.862 1 5.741 1 9.5 1H12.5C16.259 1 18.138 1 19.392 1.99C19.5933 2.15 19.7783 2.32433 19.947 2.513C21 3.693 21 5.463 21 9C21 12.537 21 14.306 19.947 15.487C19.7774 15.6767 19.5917 15.8514 19.392 16.009C18.138 17 16.26 17 12.5 17H9.5C5.741 17 3.862 17 2.607 16.01C2.40756 15.852 2.2222 15.677 2.053 15.487C1 14.307 1 12.537 1 9Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.551 9C13.551 9.66304 13.2876 10.2989 12.8188 10.7678C12.3499 11.2366 11.714 11.5 11.051 11.5C10.388 11.5 9.75207 11.2366 9.28323 10.7678C8.81439 10.2989 8.551 9.66304 8.551 9C8.551 8.33696 8.81439 7.70107 9.28323 7.23223C9.75207 6.76339 10.388 6.5 11.051 6.5C11.714 6.5 12.3499 6.76339 12.8188 7.23223C13.2876 7.70107 13.551 8.33696 13.551 9Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.e7e28eec7718f55f22a751d55bb9e5c9.svg";
export { ForwardRef as ReactComponent };